import { render, staticRenderFns } from "./AffiliateBanners.vue?vue&type=template&id=04f17149&scoped=true"
import script from "./AffiliateBanners.vue?vue&type=script&lang=js"
export * from "./AffiliateBanners.vue?vue&type=script&lang=js"
import style0 from "./AffiliateBanners.vue?vue&type=style&index=0&id=04f17149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f17149",
  null
  
)

export default component.exports